import * as React from "react";

const TextIcon = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" height={24} width={24} {...props}>
    <path d="M0 0h24v24H0V0z" fill="none" />
    <path d="M5 4v3h5.5v12h3V7H19V4z" />
  </svg>
);

export default TextIcon;
